<template>
  <div class="w-full">
    <!-- Main Navbar -->
    <div class="navbar bg-base-100 dark:bg-neutral text-base-content dark:text-neutral-content shadow-md fixed top-0 z-50 transition-all duration-300">
      <div class="container mx-auto px-2">
        <!-- Mobile Nav & Sidebar Button -->
        <div class="flex-none lg:hidden" @click="toggleMenu" v-if="menu">
          <label for="my-drawer-2" class="btn btn-square btn-ghost relative">
            <span class="absolute top-1 right-1 flex h-2 w-2">
              <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75"></span>
              <span class="relative inline-flex rounded-full h-2 w-2 bg-primary"></span>
            </span>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" class="w-6 h-6 stroke-current">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>
            </svg>
          </label>
        </div>

        <!-- Logo Section -->
        <div class="flex-1">
          <router-link to="/" class="flex items-center gap-2 transition-transform hover:scale-105 duration-300">
            <img :src="logo" alt="logo" class="md:h-12 h-10">
          </router-link>
        </div>

        <!-- Desktop Navigation Links -->
        <div class=" lg:flex flex-1 justify-center">
          <ul class="menu menu-horizontal px-1 gap-2">
            <li>
              <router-link to="/exams" class="rounded-lg font-medium group" :class="{'active': route.path === '/exams'}">
                <span class="relative">
                  Sınavlarım
                  <span class="absolute bottom-0 left-0 w-0 group-hover:w-full h-0.5 bg-primary transition-all duration-300"></span>
                </span>
              </router-link>
            </li>
            <li>
              <a href="https://kfegitim.com/" target="_blank" rel="noopener noreferrer" class="rounded-lg font-medium group">
                <span class="relative">
                  Projelerim
                  <span class="absolute bottom-0 left-0 w-0 group-hover:w-full h-0.5 bg-primary transition-all duration-300"></span>
                </span>
              </a>
            </li>
            <li>
              <a href="https://dizgi.denemem.com/" target="_blank" rel="noopener noreferrer" class="rounded-lg font-medium group">
                <span class="relative">
                  Dizgi
                  <span class="absolute bottom-0 left-0 w-0 group-hover:w-full h-0.5 bg-primary transition-all duration-300"></span>
                </span>
              </a>
            </li>
            
          </ul>
        </div>

        <!-- Actions Section -->
        <div class="flex-none flex items-center gap-1 sm:gap-2">
          <!-- Search Button -->
          <div class="hidden">
            <button class="btn btn-ghost btn-circle" @click="toggleSearch">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
            </button>
          </div>


          <!-- User Dropdown -->
          <div v-if="isLoggedIn" class="dropdown dropdown-end">
            <label tabindex="0" class="btn btn-ghost btn-sm rounded-lg gap-1 sm:gap-2 pr-1 sm:pr-4 cursor-pointer">
              <div class="avatar placeholder online">
                <div class="bg-primary text-primary-content rounded-full w-7 sm:w-8">
                  <span class="text-xs sm:text-sm">{{ userInitials }}</span>
                </div>
              </div>
              <span class="hidden md:inline truncate max-w-[120px]">{{ userData?.name }}</span>
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
              </svg>
            </label>
            <ul tabindex="0" class="dropdown-content menu shadow-lg bg-base-100 dark:bg-neutral rounded-box w-64 mt-2 p-2 z-50">
              <div class="px-4 py-3 border-b border-base-300 dark:border-neutral-700">
                <div class="flex items-center gap-3">
                  <div class="avatar placeholder">
                    <div class="bg-primary text-primary-content rounded-full w-10">
                      <span>{{ userInitials }}</span>
                    </div>
                  </div>
                  <div>
                    <p class="font-medium">{{ userData?.name }} {{ userData?.username }}</p>
                    <p class="text-xs text-base-content/70 dark:text-neutral-content/70 truncate">{{ userData?.email }}</p>
                  </div>
                </div>
              </div>
              <li class="menu-title mt-2">
                <span>Hesabım</span>
              </li>
              <li v-can="['UsersDetail']">
                <router-link :to="`/users/detail/${userData?.id}`" class="flex items-center p-3 group">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2 group-hover:text-primary transition-colors" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                  </svg>
                  <div>
                    <div class="font-medium group-hover:translate-x-1 transition-transform duration-300">Profilim</div>
                    <div class="text-xs opacity-60">Profil bilgilerini görüntüle</div>
                  </div>
                </router-link>
              </li>
              <li v-can="['UsersUpdate']">
                <router-link :to="`/users/update/${userData?.id}`" class="flex items-center p-3 group">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 mr-2 group-hover:text-primary transition-colors">
                    <path stroke-linecap="round" stroke-linejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
                  </svg>
                  <div>
                    <div class="font-medium group-hover:translate-x-1 transition-transform duration-300">Profili Düzenle</div>
                    <div class="text-xs opacity-60">Bilgilerini güncelle</div>
                  </div>
                </router-link>
              </li>
  
              <div class="divider my-1" v-can="['UsersLogout']"></div>
              <li v-can="['UsersLogout']">
                <a @click="logOutFNC" class="flex items-center p-3 text-error hover:bg-error/10 group">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 mr-2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9" />
                  </svg>
                  <div>
                    <div class="font-medium group-hover:translate-x-1 transition-transform duration-300">Çıkış Yap</div>
                    <div class="text-xs opacity-60">Hesabından çıkış yap</div>
                  </div>
                </a>
              </li>
            </ul>
          </div>



          <FirebaseLogin v-if="!isDenememSite" :template="1" />
          <div v-else>
            <!-- Denemem site için giriş yapmamış kullanıcılar için butonlar -->
            <div v-if="!isLoggedIn" class="flex items-center gap-2">
              <router-link to="/users/login" class="btn btn-primary btn-sm">
                Giriş Yap
              </router-link>
              <router-link to="/users/signIn" class="btn btn-outline btn-sm">
                Üye Ol
              </router-link>
            </div>
          </div>
          
        </div>
      </div>
    </div>

    <!-- Search Overlay -->
    <div v-if="showSearch" class="fixed inset-0 bg-black/50 z-[60] flex items-start justify-center pt-20">
      <div class="bg-base-100 dark:bg-neutral w-full max-w-2xl mx-4 rounded-lg shadow-xl p-4 animate-slideDown">
        <div class="flex justify-between items-center mb-4">
          <h3 class="font-bold text-lg">Arama</h3>
          <button @click="showSearch = false" class="btn btn-sm btn-circle btn-ghost">✕</button>
        </div>
        <div class="form-control">
          <div class="input-group w-full flex gap-1">
            <input type="text" placeholder="Ara..." class="input input-bordered w-full focus:outline-none" ref="searchInput" />
            <button class="btn btn-square btn-primary">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
            </button>
          </div>
        </div>
        <div class="mt-4">
          <p class="text-sm opacity-70">Hızlı Bağlantılar:</p>
          <div class="flex flex-wrap gap-2 mt-2">
            <router-link to="/tasks" class="badge badge-outline p-3">Görevler</router-link>
            <router-link to="/users" class="badge badge-outline p-3">Kullanıcılar</router-link>
          </div>
        </div>
      </div>
    </div>

    <!-- Mobile Menu Dropdown Button (for pages without sidebar) -->
    <div class="lg:hidden fixed bottom-4 right-4 z-40" v-if="!menu && isLoggedIn">
      <button class="btn btn-primary shadow-lg btn-circle flex items-center justify-center" onclick="document.getElementById('mobile-menu-modal').showModal()">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>
    </div>

    <!-- Mobile Menu Modal -->
    <dialog id="mobile-menu-modal" class="modal modal-bottom sm:modal-middle">
      <div class="modal-box bg-base-100 dark:bg-neutral">
        <!-- User Info in Modal -->
        <div class="flex items-center space-x-3 border-b pb-4 mb-4 border-base-300 dark:border-neutral-700" v-if="isLoggedIn">
          <div class="avatar placeholder">
            <div class="bg-primary text-primary-content rounded-full w-12">
              <span class="text-lg">{{ userInitials }}</span>
            </div>
          </div>
          <div>
            <div class="font-bold">{{ userData?.name }} {{ userData?.username }}</div>
            <div class="text-sm opacity-60">{{ userData?.email || 'Kullanıcı' }}</div>
          </div>
        </div>
        
        <h3 class="font-bold text-lg mb-4">Menü</h3>
        <div class="py-2">
          <ul class="menu bg-base-100 dark:bg-neutral rounded-box w-full gap-1">
            <li>
              <router-link to="/" class="flex items-center py-3" @click="closeModal">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                </svg>
                Ana Sayfa
              </router-link>
            </li>
            <li v-if="isLoggedIn">
              <router-link :to="`/users/detail/${userData?.id}`" class="flex items-center py-3" @click="closeModal">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
                Profilim
              </router-link>
            </li>
            <li>
              <router-link to="/exams" class="flex items-center py-3" @click="closeModal">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                </svg>
                Sınavlarım
              </router-link>
            </li>
            <li>
              <router-link to="/exams/list" class="flex items-center py-3" @click="closeModal">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                </svg>
                Sınav Havuzu
              </router-link>
            </li>
            <li>
              <router-link to="/images" class="flex items-center py-3" @click="closeModal">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                </svg>
                Soru Resimleri
              </router-link>
            </li>
            <li>
              <a href="https://kfegitim.com/" target="_blank" rel="noopener noreferrer" class="flex items-center py-3" @click="closeModal">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                </svg>
                Projelerim
              </a>
            </li>
          </ul>
        </div>
        <div class="flex flex-col gap-2 mt-4 pt-4 border-t border-base-300 dark:border-neutral-700">
          <button @click="logOutFNC" v-if="isLoggedIn" class="btn btn-outline btn-error btn-sm mt-2">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 mr-2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9" />
            </svg>
            Çıkış Yap
          </button>
        </div>
        <div class="modal-action">
          <form method="dialog">
            <button class="btn">Kapat</button>
          </form>
        </div>
      </div>
    </dialog>

    <!-- Spacer to prevent content from being hidden under fixed header -->
    <div class="h-16"></div>
  </div>
</template>

<script setup>
import { getCurrentInstance, ref, computed, defineProps, defineEmits, onMounted, nextTick } from "vue";
import { UserCircleIcon } from "@heroicons/vue/24/solid";
import { useRouter, useRoute } from "vue-router";
import useModelUsers from "../../compositions/useModelUsers";
import useFirebaseAuth from "../../compositions/useFirebaseAuth";
import { useStore } from 'vuex';
import FirebaseLogin from "../other/FirebaseLogin.vue";
import useUrl from "../../compositions/useUrl";

const { url, logo } = useUrl();


const app = getCurrentInstance();
const store = useStore();
const props = defineProps(["menu"]);
const emit = defineEmits(['toggle-menu']);
const router = useRouter();
const route = useRoute();
const { logOut } = useModelUsers();

// Search functionality
const showSearch = ref(false);
const searchInput = ref(null);

const toggleSearch = () => {
  showSearch.value = !showSearch.value;
  if (showSearch.value) {
    nextTick(() => {
      searchInput.value.focus();
    });
  }
};

// Menu toggle functionality
const toggleMenu = () => {
  emit('toggle-menu');
};

const closeModal = () => {
  document.getElementById('mobile-menu-modal').close();
};

// Use Firebase auth composable
const { 
  user,
  isLoggedIn,
  logout
} = useFirebaseAuth();


// Convert Firebase user to app user format
const userData = computed(() => {
  if (!user.value) return null;
  return {
    id: user.value.uid,
    email: user.value.email,
    name: user.value.displayName || '',
    username: user.value.email?.split('@')[0] || '',
  };
});

const logOutFNC = async () => {
  try {
    await logout();
    store.commit("logoutUser");
    router.push({name: "HomePage"});
  } catch (error) {
    console.error("Logout failed:", error);
  }
};

const userInitials = computed(() => {
  if (!userData.value) return '';
  return (userData.value.name?.charAt(0) || '') + (userData.value.username?.charAt(0) || '');
});

// VITE_SITE değişkenini kontrol et
const isDenememSite = computed(() => {
  return import.meta.env.VITE_SITE === 'denemem'
});
</script>

<style scoped>
.dropdown-content {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

@media (max-width: 768px) {
  .navbar {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
}

.animate-slideDown {
  animation: slideDown 0.3s ease-out;
}

@keyframes slideDown {
  from {
    transform: translateY(-20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
</style>
